import React, { useState } from "react";
import axios from "axios";
import "./style.scss";
// import Navbar from "../../components/Navbar";
// import Footer from "../../components/Footer";
// import AppFooter from "../../components/AppFooter";
// import Select from "../../Utils/Select";
import CustomModal from "../../Utils/CustomModal";
import NavbarEmpty from "../../components/NavbarEmpty";
// import usePixelFacebook from "../../Utils/Hooks/usePixelFacebook";

const RequestDataDeletion = () => {
  // usePixelFacebook();
  const initForm = {
    identifier: "",
  };
  const [contactForm, setContactForm] = useState(initForm);
  const messageCb = {
    valid:
      "Votre email est envoyé avec succès, vous allez recevoir un mail de confirmation ou un appel de notre equipe support dans 3 à 5 jours ouvrables",
    error: "Votre mail est envoyé avec succès",
  };
  const [modalMessage, setModalMessage] = useState(messageCb.error);
  const [modalOpen, setModalOpen] = useState(false);

  const handleChange = (e) => {
    // console.log(" input ", e.target.name, e.target.value);
    setContactForm({ [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    // Handle form submission here
    // console.log("before ", contactForm);
    if (Object.keys(initForm).some((attr) => !contactForm[attr])) {
      return;
    }
    // console.log("after ", contactForm);
    await axios({
      method: "post",
      url: "https://dev.mooshir.com/api/v1/customer/account/delete",
      data: {
        [/@/gi.test(contactForm.identifier) ? "email" : "phone"]:
          contactForm.identifier,
      },
      headers: {
        "Content-Type": "application/json",
      },
    }).then((response) => {
      if (!!response && !!response?.status === 200) {
        setModalMessage(messageCb.valid);
      } else {
        setModalMessage(messageCb.error);
      }
      setModalOpen(true);
    });

    // Reset form fields if needed
    setContactForm(initForm);
  };

  return (
    <div className="contact">
      <NavbarEmpty />
      <div className="contact-content">
        <form onSubmit={handleSubmit} method="POST">
          <div className="form-content">
            <div>
              <img
                className="delete-account-image"
                alt="icon"
                src={require("../../../assets/delete-account.svg").default}
              />
              <h2>Suppression du compte MOOSHIR</h2>
              <h4>
                Cette politique s'applique à l'application{" "}
                <a
                  href="https://play.google.com/store/apps/details?id=com.mooshir"
                  target="_blank"
                  rel="noreferrer"
                >
                  Mooshir: immobilier & services
                </a>{" "}
                Réaliser par{" "}
                <a
                  href="https://play.google.com/store/apps/dev?id=6166252777318454247"
                  target="_blank"
                  rel="noreferrer"
                >
                  Fenovation SPAS
                </a>{" "}
                .
              </h4>
              <p className="contact-p">
                Toutes vos informations personnelles seront supprimées de notre
                base de données (Nom, prénom, avatar, adresse email, numéro de
                mobile, vos annonces, si elles existent, vos informations
                Relatives à l'authentification par Google ou Apple).
              </p>
              <p className="contact-p">
                Nous vous remercions sincèrement pour avoir fait partie de notre
                communauté via notre application Mooshir. Votre soutien a été
                précieux et nous vous souhaitons le meilleur.
              </p>
            </div>

            <div id="form-input">
              <div className="input-container">
                <div className="form-content2">
                  {/* <img
                    className="email-image"
                    alt="icon"
                    src={require("../../../assets/email.svg").default}
                  /> */}
                  <div className="row-div">
                    <h4>Email / Mobile</h4>
                  </div>
                </div>
                <input
                  type="text"
                  placeholder="Adresse mail / Numéro de mobile"
                  name="identifier"
                  value={contactForm.identifier}
                  onChange={handleChange}
                  style={{ backgroundColor: "#F7F7F7" }}
                />
                {/* <p className="error-message message-absolute">
                  Ce champ est requis{" "}
                </p> */}
              </div>
              <button
                id="button"
                type="submit"
                // onClick={() => console.log("click on send message")}
              >
                <span id="span">Vérifier mon compte</span>
              </button>
              <p className="form-contact-p4">
                Vous allez recevoir un email de vérification que votre compte a
                été supprimé, ou un appel de notre équipe support dans un délai
                au maximum de 5 jours ouvrables.
              </p>
            </div>
          </div>
        </form>
      </div>

      <CustomModal message={modalMessage} open={modalOpen} />
    </div>
  );
};

export default RequestDataDeletion;
